import { __extends } from "tslib";
import { GetObjectLegalHoldOutput, GetObjectLegalHoldRequest } from "../models/index";
import { deserializeAws_restXmlGetObjectLegalHoldCommand, serializeAws_restXmlGetObjectLegalHoldCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetObjectLegalHoldCommand = /** @class */ (function (_super) {
    __extends(GetObjectLegalHoldCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetObjectLegalHoldCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetObjectLegalHoldCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetObjectLegalHoldRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetObjectLegalHoldOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetObjectLegalHoldCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetObjectLegalHoldCommand(input, context);
    };
    GetObjectLegalHoldCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetObjectLegalHoldCommand(output, context);
    };
    return GetObjectLegalHoldCommand;
}($Command));
export { GetObjectLegalHoldCommand };
//# sourceMappingURL=GetObjectLegalHoldCommand.js.map